import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import axios from 'axios';

const BASE_URL =
	window.location.hostname === 'localhost' ? 'http://localhost:8000' : 'https://dlqw5ngx5xpnk.cloudfront.net';

const ResetPassword = () => {
	const [form, setForm] = useState({ password: '', confirmPassword: '' });
	const [status, setStatus] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	// Get token from URL
	const params = new URLSearchParams(location.search);
	const token = params.get('token');

	// Check if this is admin reset password
	const isAdmin = location.pathname.includes('/admin');

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
		setError('');
		setStatus('');
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setStatus('');
		if (!form.password || !form.confirmPassword) {
			setError('Both fields are required');
			return;
		}
		if (form.password !== form.confirmPassword) {
			setError('Passwords do not match');
			return;
		}
		if (!token) {
			setError('Invalid or expired reset link.');
			return;
		}
		setLoading(true);
		try {
			const endpoint = isAdmin ? `${BASE_URL}/api/admin/reset-password` : `${BASE_URL}/api/auth/reset-password`;
			const res = await axios.post(endpoint, { token, password: form.password });
			if (res.data.success) {
				setStatus('Password reset successful! You can now log in.');
				setTimeout(() => navigate(isAdmin ? '/admin/login' : '/login'), 2000);
			} else {
				setError(res.data.message || 'Reset failed');
			}
		} catch (err) {
			setError(err.response?.data?.message || err.message || 'Reset failed');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="container">
			<Row>
				<Col xl="12">
					<h2 className="personalinfo_head2">Reset Password</h2>
				</Col>
			</Row>
			<Row>
				<Col xl="4">
					<div className="formbg">
						<h3>Reset Password</h3>
						<form onSubmit={handleSubmit}>
							<div className="form-floating mb-3 mt-3">
								<input
									type="password"
									className="form-control form_custom"
									id="password"
									placeholder="Enter New Password"
									name="password"
									value={form.password}
									onChange={handleChange}
									required
								/>
								<label htmlFor="password">
									New Password <span className="text-danger">*</span>
								</label>
							</div>
							<div className="form-floating mb-3 mt-3">
								<input
									type="password"
									className="form-control form_custom"
									id="confirmPassword"
									placeholder="Confirm New Password"
									name="confirmPassword"
									value={form.confirmPassword}
									onChange={handleChange}
									required
								/>
								<label htmlFor="confirmPassword">
									Confirm Password <span className="text-danger">*</span>
								</label>
							</div>
							<button className="login_btn" type="submit" disabled={loading}>
								{loading ? 'Resetting...' : 'Reset Password'}
							</button>
							{error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
							{status && <div style={{ color: 'green', marginTop: 10 }}>{status}</div>}
						</form>
					</div>
				</Col>
				<Col xl="8">
					<div className="login_content">
						<h4>Fellowship Application Timeline</h4>
						<h5>Deadline </h5>
						<p>
							Completed applications must be submitted by <span>December 10, 2025.</span>
						</p>
						<h5>Selection</h5>
						<p>
							Applicants will be notified of their acceptance status by <span>December 24, 2025.</span>
						</p>
						<p>
							Selected applicants must confirm their acceptance of the fellowship offer by{' '}
							<span>December 31, 2025.</span>
						</p>
						<h5>Commencement</h5>
						<p>
							The fellowship officially begins on <span>January 1, 2026.</span>
						</p>
						<p>
							We encourage meaningful voices to join us in contributing to and enriching the narrative surrounding
							India's journey forward!
						</p>
					</div>
				</Col>
			</Row>
		</div>
	);
};

export default ResetPassword;
